import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  locale: "en", // 默认语言
  fallbackLocale: "en", // 如果找不到当前语言的翻译，默认回退到的语言
  messages: {
    en: {
      toggleLanguage: "en",
      title: "Angel Legion",
      account_cancellation_title: "Account Cancellation",
      username: "Username",
      password: "Password",
      button_login: "Login",
      welcome: "Welcome",
      select_server: "Select Server",
      logout_account: "Cancellation Account",
      logout: "go to back",
      please_select_server: "Please select Server!",
      logout_account_successful: "Cancellation successful.(During this period, please do not log in and use this account to ensure the smooth completion of the cancellation, otherwise you will be deemed to have withdrawn the cancellation application.)",
      logout_account_has: "Your account is currently in the process of being logged out.",
      auth_timeout: "Session has expired, please log in again.",
      logout_no_player: "Account has been cancellation.",
      // 确认框
      are_you_sure: "Please note that there is a 15-day cooling-off period (account lockout period) for the account cancellation. Except as provided by laws and regulations and the cancellation agreement, we will complete the cancellation, delete or anonymize your personal information after the cooling-off period expires.",
      confirm: "Confirm",
      ok: "OK",
      cancel: "Cancel",
      // weihu
      weihu1: "Website Under Maintenance",
      weihu2: "Please try again later.",
      //
      server_weihu: "The server is currently undergoing maintenance.",
      check_player: "Detected Role",
      no_check_player: "Role Not Detected",
      // 步骤
      step_1: "Login",
      step_2: "Read Agreement",
      step_3: "Cancellation",
      // 阅读协议相关
      game_account_cancellation_agreement: "Game Account Cancellation Agreement",
      agreement_have_read: "I have read and agree Game Account Cancellation Agreement",
      agreement_next: "Next",
      agreement_no: "Please read and agree",
      // 
      error_exception: "Page exception, please refresh the page.",
      error_null_username_or_password: "Username or password cannot be empty.",
      error_username_or_password: "Username or password is incorrect. Please enter again.",
      error_many_login: "Multiple failed login attempts, please try again after 24 hours.",
      error_login_fail: "Login failed, please try again later.",
      error_server_response: "Server response failed, please try again later.",
      error_logout_account_failed: "Cancellation failed, please try again later.",
      error_too_many_request: "Server busy, please try again later."
    },
    zh: {
      toggleLanguage: "zh",  
      title: "女神星球",
      account_cancellation_title: "帐号注销",
      username: "用户名",
      password: "密码",
      button_login: "登录",
      welcome: "欢迎",
      select_server: "选择服务器",
      logout_account: "注销",
      logout: "退出登录",
      please_select_server: "请选择服务器！",
      logout_account_successful: "注销帐号成功！(在15天冷静期内，请您不要登录和使用该账号，以确保注销的顺利完成，否则视为您撤销注销申请。)",
      logout_account_has: "您的帐户当前正处于注销状态。",
      auth_timeout: "登录已过期，请重新登录。",
      logout_no_player: "帐号已经被注销",
      // 确认框
      are_you_sure: "请注意，该账号注销有15日的冷静期(账号锁定期)。除法律法规规定和注销协议约定情形外，我们将在冷静期满后完成注销，删除或匿名化处理您的个人信息。",
      confirm: "确认",
      ok: "确定",
      cancel: "取消",
      // weihu
      weihu1: "网站维护中",
      weihu2: "请稍后再试",
      //
      server_weihu: "该服务器正在维护中",
      check_player: "检测到角色",
      no_check_player: "未检测到角色",
      //step
      step_1: "登录",
      step_2: "阅读协议",
      step_3: "注销帐号",
      // 阅读协议相关
      game_account_cancellation_agreement: "游戏帐号注销协议",
      agreement_have_read: "我已经阅读并且同意游戏帐号注销协议",
      agreement_next: "继续",
      agreement_no: "请阅读并同意",
      // 
      error_exception: "页面异常，请重新刷新页面",
      error_null_username_or_password: "用户名或密码不能为空",
      error_username_or_password: "用户名或密码不正确，请重新输入",
      error_many_login: "多次尝试登录失败，请24小时后再试",
      error_login_fail: "登录失败，请稍后再试",
      error_server_response: "服务器响应失败，请稍后再试",
      error_logout_account_failed: "注销失败，请稍后再试。",
      error_too_many_request: "服务器繁忙，请稍后再试"
    }
    // 可以根据需要添加更多语言翻译
  }
});

export default i18n;